export default __webpack_public_path__ + "static/media/Google.30160142.svg";